import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFlag16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconFlag16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3 10v4.5a.5.5 0 0 0 1 0V10h9.88a.5.5 0 0 0 .372-.834L11.412 6l2.84-3.166A.5.5 0 0 0 13.88 2H4v-.5a.5.5 0 0 0-1 0zm1-7v6h8.76l-2.092-2.332L10.07 6l.598-.668L12.76 3z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFlag16);
